import * as React from "react";
const SvgFiRrRevenueAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-revenue-alt_svg__a)">
      <path
        fill="#062147"
        d="M16 19c0 1.654-1.346 3-3 3v1a1 1 0 1 1-2 0v-1h-.268a3.01 3.01 0 0 1-2.598-1.499 1 1 0 1 1 1.73-1.001c.18.308.511.5.867.5H13a1 1 0 0 0 1-1 .77.77 0 0 0-.644-.76l-3.04-.507A2.76 2.76 0 0 1 7.998 15c0-1.654 1.346-3 3-3v-1a1 1 0 1 1 2 0v1h.268a3.01 3.01 0 0 1 2.598 1.499 1 1 0 1 1-1.73 1.001 1.01 1.01 0 0 0-.867-.5H11a1 1 0 0 0-1 1c0 .378.271.698.644.76l3.041.507A2.76 2.76 0 0 1 16 19m7.707-8.121-2.293-2.293a2 2 0 0 0-2.828 0l-2.293 2.293a.999.999 0 1 0 1.414 1.414L19 11v12a1 1 0 1 0 2 0V11l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414m-14-6.586L11 3v4a1 1 0 1 0 2 0V3l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L13.414.586a2 2 0 0 0-2.828 0L8.293 2.879a.999.999 0 1 0 1.414 1.414m-2 3.586L5.414 5.586a2 2 0 0 0-2.828 0L.293 7.879a.999.999 0 1 0 1.414 1.414L3 8v15a1 1 0 1 0 2 0V8l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-revenue-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRevenueAlt;
